/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useCallback,
    useEffect,
    useState,
    useContext
} from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLEndorsementFlowUtil, MLCapitalizeStringFilter, MLEndorsementUtil } from 'ml-portals-util-js';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLAvailableInsuredCandidatesUtil } from 'ml-portals-util-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import { MLPolicyChangeDataHolderService, MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { MLInsuredCandidatesComponent } from 'ml-components-common-react';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import MLPAEditDriverComponent from '../../../../modules-react/ml-components-common-react/MLPAEditDriverComponent/MLPAEditDriverComponent';
import MLReasonComponent from '../../components/MLReasonComponent/MLReasonComponent';
import MLDriverChangeDisclosureComponent from '../../components/MLDriverChangeDisclosureComponent/MLDriverChangeDisclosureComponent';
import MLPartialDriverDetailsComponent from '../../components/MLPartialDriverDetailsComponent/MLPartialDriverDetailsComponent';
import metadata from './DriversPagePolChange.metadata.json5';
import {
    MLPortalStorageService
} from 'ml-services-common-react';

import messages from './DriversPagePolChange.messages.js';
import styles from './DriversPagePolChange.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';

const alertNames = {
    addedDriverName: 'addedDriver',
    removedDriverName: 'removedDriver',
    addedHouseholdMemberName: 'addedHouseholdMember',
    excludedDriverName: 'excludedDriver',
    exclusionNotAllowed: 'exclusionNotAllowed',
    excludingNamedInsuredAlert: 'excludingNamedInsuredAlert',
    excludingLicensedSpouseAlert: 'excludingLicensedSpouseAlert',
    excludingOnlyDriverAlert: 'excludingOnlyDriverAlert',
    alreadyExcludedUnwanted: 'alreadyExcludedUnwanted',
    alreadyExcludedLicense: 'alreadyExcludedLicense'
};

const ENDORSEMENT_PA_DRIVERS_STEPNAME = 'endorsementPaDrivers';

const DriversPagePolChange = (props) => {
    const {
        wizardData,
        updateWizardData,
        goNext,
        currentStepIndex,
        steps,
        changeNextSteps,
        currentStep
    } = props;
    const { submissionVM, alertMessages = [] } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();

    const {
        showProgressDialog
    } = MLModalService();

    const {
        clearAlerts,
        clearBlockAlerts,
        addErrorAlert
    } = MLNotificationBlockUtil();

    const {
        isDriverRemovalExclusion,
        isDriverRemovalNotInHousehold,
        isDriverRemovalDuplicate,
        isDriverRemovalDeceased,
        isDriverRemovalUnknown,
        isSpouse,
        isLicensed,
        getHouseholdNonDriverType,
        getExcludedDriverType,
        getFullName,
        setModifierEditMode,
        setSpousesForDriver,
        checkUniqueSelf,
        checkUniqueSpouse,
        checkIfNonDriver,
        validateExcludedDriverAddition,
        unobtainableDriverLicense,
        displayUnobtainableDriverLicenseMessage,
        isDriverRemovalAddRatedDriver,
        getRatedDriverType,
        hasDuplicateSignalPhoneNumbers
    } = MLDriverVehicleUtil();

    const {
        addRemovedDriverToAvailableCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const isGPA = appConfig.portalCode === 'GPA';
    const isAMP = appConfig.portalCode === 'AMP';
    const DRIVERS_PATH = 'lobData.personalAuto.coverables.drivers';
    const driversVM = _.get(submissionVM, DRIVERS_PATH, []);
    const driversVal = _.get(submissionVM, `${DRIVERS_PATH}.value`, {});
    const paCoverableVal = _.get(submissionVM, 'lobData.personalAuto.coverables.value', {});
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const policyState = _.get(submissionVM, "baseData.policyAddress.state.value.code");
    const accidentPreventionCode = 'PADriversRoleModiferPreventionCourse_ML';
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const directRemoveStatuses = ['unknown', 'not_household', 'notresiding'];
    const ML_STORAGE_KEY_SHOW_EXCLUSION_AGREEMENT = "SHOW_EXCLUSION_AGREEMENT"
    const [pageAction, setPageAction] = useState('');
    const [driver, setDriver] = useState(viewModelService.create({}, 'pc', 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.DriverDTO'));
    const [driverType, setDriverType] = useState(currentStep.driverType || MLPolicyChangeDataHolderService.getDriverType());
    const [oldDriverStatus, setOldDriverStatus] = useState(null);
    const [showValidationErrors, setShowValidationErrors] = useState(false);
    const [showAccidentPreventionDiscountAlert, setShowAccidentPreventionDiscountAlert] = useState(false);
    const [unobtainableDriverLicenseDisplayed, setUnobtainableDriverLicenseDisplayed] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [insuredCandidateSelected, setInsuredCandidateSelected] = useState(false);
    const [isBackwardsNavigation, setIsBackwardsNavigation] = useState(false);

    const { onValidate, isComponentValid } = useValidation('DriversPagePolChange');

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const addNewDriver = () => {
        const newDriver = paCoverableVal.createDriver();
        newDriver.person.primaryAddress = submissionVM.baseData.policyAddress.value;
        newDriver.editMode_ML = true;
        newDriver.type_ML = driverType;
        newDriver.isAgentCreated = true;
        newDriver.disclosures_ML = _.get(driver, 'disclosures_ML.value');
        return driversVM.findFirstElement(newDriver);
    };

    const getSelectedDriver = () => {
        let index = driversVal.findIndex((drv) => drv.isSelected === true);
        if (index === -1) {
            index = driversVal.findIndex((drv) => drv.fixedId === currentStep.fixedId);
        }
        if (index === -1) {
            return addNewDriver();
        }
        setIsBackwardsNavigation(true);
        setInsuredCandidateSelected(true);

        return driversVM.getElement(index);
    };

    const saveDriverInPortalStorage = (driverToSave) => {
        if ((driverToSave.status_ML === "unwanted" || driverToSave.status_ML === "license_revoked" || driverToSave.status_ML ===
            "own_insurance" || driverToSave.status_ML === "unabletodrive" ||  driverToSave.status_ML === 'registeredowner') && (driverToSave.type_ML === "excluded") && (submissionVM.baseData.policyAddress.state.value.code === 'OR')) {
            MLPortalStorageService.store(submissionVM.value.jobID, null, ML_STORAGE_KEY_SHOW_EXCLUSION_AGREEMENT, JSON.stringify(driverToSave), authHeader)
        }
    }

    const getMissingStatus = (drv) => {
        return drv.value.type_ML === 'rated' ? "insure_driver" : null;
    };

    const setCurrentDriverVM = () => {
        let sideBarMessage;
        switch (MLPolicyChangeDataHolderService.getPageAction()) {
            case 'add': {
                setPageAction('add');
                const selectedDriver = getSelectedDriver();
                setDriver(selectedDriver);
                sideBarMessage = driverType === 'rated' ? messages.addDriverSideBar : messages.addExcludedDriverSideBar;
                MLNavigationStepsTrackingService.addToDynamicSteps(translator(sideBarMessage), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                break;
            }
            case 'edit': {
                setPageAction('edit');
                const selectedEditDriver = getSelectedDriver();
                selectedEditDriver.value.isAgentCreated = true; // Makes help text next to DOB not show
                selectedEditDriver.value.editMode_ML = true;
                setDriver(selectedEditDriver);
                setOldDriverStatus(selectedEditDriver.value.status_ML);
                setModifierEditMode(driversVal, true);
                sideBarMessage = driverType === 'rated' ? messages.editDriverSideBar : messages.editExcludedDriverSideBar;
                MLNavigationStepsTrackingService.addToDynamicSteps(translator(sideBarMessage), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                break;
            }
            case 'remove': {
                setPageAction('remove');
                const selectedRemoveDriver = getSelectedDriver();
                setDriver(selectedRemoveDriver);
                setOldDriverStatus(selectedRemoveDriver.value.status_ML || getMissingStatus(selectedRemoveDriver));
                selectedRemoveDriver.value.status_ML = null;
                sideBarMessage = driverType === 'rated' ? messages.removeDriverSideBar : messages.removeExcludedDriverSideBar;
                MLNavigationStepsTrackingService.addToDynamicSteps(translator(sideBarMessage), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                break;
            }
            default:
                break;
        }
    };

    const isAccidentPreventionCourse = () => {
        let nonAcciPrevModifier = false;
        const driversArray = _.get(submissionVM, "value.lobData.personalAuto.coverables.drivers");
        if (policyState === 'GA') {
            driversArray.forEach((dr) => {
                if (dr.driverModifiers_ML?.modifiers) {
                    dr.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.codeIdentifier_ML === accidentPreventionCode) {
                            if (modifier.chosenTermValue === 'false') {
                                nonAcciPrevModifier = true;
                            }
                        }
                    });
                }
            });
        }
        return nonAcciPrevModifier;
    };

    useEffect(() => {
        if (isGPA) {
            PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Drivers Screen' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initDriverPage = () => {
        if (alertMessages.length > 0) {
            const poppedAlert = alertMessages.pop();
            clearBlockAlerts(poppedAlert.alertName);
        }
        if (currentStep.pageAction) {
            MLPolicyChangeDataHolderService.setPageAction(currentStep.pageAction);
        }
        if (currentStep.driverType) {
            MLPolicyChangeDataHolderService.setDriverType(currentStep.driverType);
            setDriverType(currentStep.driverType);
        }
        setCurrentDriverVM();
    };

    useEffect(() => {
        if (MLEndorsementFlowUtil.startingPointPageLoadIsSkipping(submissionVM, goNext, steps, currentStepIndex, changeNextSteps)) {
            return;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        initDriverPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.nextBaseDescription}
                values={{
                    bold: (
                        <strong>{translator(messages.nextDescriptionBold)}</strong>
                    )
                }}
            />
        );
    };
        const getFullNameNoSuffix = (drv) => {
        const person = drv.person;
        return `${person.firstName} ${person.middleName || ''}${person.middleName ? ' ' : ''}${person.lastName}`;
    };


    const getDisplayNameForNonDriver = (drv) => {
        const person = drv?.person;     
        const suffix = person?.displayFullName_Ext?.split(",")[1]?.trim();       
        return `${person.firstName} ${person.middleName || ''}${person.lastName} ${suffix || ''} `
    };

    const getBoldMessage = (message) => {
        return <FormattedMessage
            {...messages.boldWrapper}
            values={{
                bold: (
                    <strong>{translator(message)}</strong>
                )
            }}
        />;
    };

    const undoDriverRemoval = (removedDriver) => {
        removedDriver.isSelected = false;
        driversVM.pushElement(removedDriver);
        const poppedAlert = alertMessages.pop();
        clearBlockAlerts(poppedAlert.alertName);
    };

    const undoChangeToHousehold = (selectedDriver, originalDriver) => {
        selectedDriver.type_ML = originalDriver.type_ML;
        selectedDriver.status_ML = originalDriver.status_ML;
        const poppedAlert = alertMessages.pop();
        clearBlockAlerts(poppedAlert.alertName);
        updateWizardSubmissionData(submissionVM);
    };

    const addDriverAlert = (selectedDriver) => {
        const alertMsg = {
            alertName: alertNames.addedDriverName,
            formattedMessageName: 'driverHasBeenAdded',
            messagePram: getFullNameNoSuffix(selectedDriver)
        };
        alertMessages.push(alertMsg);
    };

    const addHouseholdAlert = (selectedDriver, originalDriver) => {
        const alertMsg = {
            alertName: alertNames.addedHouseholdMemberName,
            formattedMessageName: isModernProduct ? 'driverHasBeenAddedAsNonDriver' : 'driverHasBeenAddedAsHouseholdMember',
            messagePram: getDisplayNameForNonDriver(selectedDriver),
            actionFn: () => undoChangeToHousehold(selectedDriver, originalDriver)
        };
        alertMessages.push(alertMsg);
    };

    const addExcludedAlert = (selectedDriver) => {
        const help = {
            title: translator(messages.driverExclusionHelpTitle),
            message: translator(messages.driverExclusionHelpText)
        };

        const alertMsg = {
            alertName: alertNames.excludedDriverName,
            formattedMessageName: 'driverExcludedNotCovered',
            messagePram: getDisplayNameForNonDriver(selectedDriver),
            help: help
        };
        alertMessages.push(alertMsg);
    };

    const addExclusionNotAllowedAlert = () => {
        const alertMsg = {
            type: 'warning',
            alertName: alertNames.exclusionNotAllowed,
            formattedMessageName: 'exlcusionNotAllowed'
        };
        alertMessages.push(alertMsg);
    };

    const removeDriverAlert = (removedDriver) => {
        const alertMsg = {
            alertName: alertNames.removedDriverName,
            formattedMessageName: 'driverHasBeenRemoved',
            messagePram: getDisplayNameForNonDriver(removedDriver),
            actionFn: () => undoDriverRemoval(removedDriver)
        };
        alertMessages.push(alertMsg);
    };

    const jumpToSelectedStepByStepID = (newStepID) => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, steps, currentStepIndex, changeNextSteps, goNext, productCode);
    };

    const saveEndorsement = () => {
        submissionVM.value.portalCurrentStep_ML = currentStep.mlStepName;
        const promise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(messages.saving, promise);
        promise.then((updatedPolicyChange) => {
            const policyChange = new PolicyChange(Object.assign({}, updatedPolicyChange));
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');

            const index = updatedEndorsementVM.lobData.personalAuto.coverables.drivers.value.findIndex(
                (drv) => drv.fixedId === driver.fixedId.value || driversVal.findIndex((driverVal) => driverVal.fixedId === drv.fixedId) === -1);
            const selectedDriver = updatedEndorsementVM.lobData.personalAuto.coverables.drivers.getElement(index);

            const details = {
                data: getFullName(selectedDriver.person.value),
                fixedId: selectedDriver.fixedId.value,
                pageAction,
                driverType
            };

            updateWizardSubmissionData(updatedEndorsementVM);
            const lbl = MLEndorsementUtil.stepLabel(currentStep);
            MLEndorsementUtil.setEndorsementDescription(lbl, updatedEndorsementVM, translator);

            MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
            jumpToSelectedStepByStepID('endorsementAdditionalChanges');
        });
    };

    const checkAndRemoveSchoolAddressIfNotDistantStudent = () => {
        if (isModernProduct) {
            driversVal.forEach((drv) => {
                if (drv.type_ML === 'rated') {
                    const modifiersList = drv?.driverModifiers_ML?.modifiers;
                    if (Array.isArray(modifiersList)) {
                        modifiersList.forEach((modifier) => {
                            if (modifier.codeIdentifier_ML === 'PADistantStudent_Ext') {
                                if (modifier.chosenTermValue === 'true') {
                                    drv.isSchoolAddressRequired_Ext = true;
                                } else {
                                    drv.schoolAddress_Ext = undefined;
                                    drv.isSchoolAddressRequired_Ext = false;
                                }
                            }
                        });
                    }
                }
            });
        }
    };

    const getRatedDrivers = () => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);

        const ratedDrivers = _.filter(
            drivers,
            (driver) => {
                return driver.type_ML.value.code === 'rated';
            }
        );

        return ratedDrivers;
    }

    const onNext = () => {
        checkAndRemoveSchoolAddressIfNotDistantStudent();

        const isValid = checkUniqueSelf(driversVal) && checkUniqueSpouse(driversVal) && submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;
        if (!isValid) {
            setShowValidationErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        }

        if (!isComponentValid) {
            setTimeout(()=>{
                setShowValidationErrors(true);
                setErrorTimestamp(errorTimestamp+1);
            }, 100);
            return false;
        }

        if (hasDuplicateSignalPhoneNumbers(getRatedDrivers())) {
            addErrorAlert(messages.duplicateSignalPhoneNumberMessage, 'duplicateSignalPhone');
            
            return false;
        }

        if (!!driver.licenseState.value && unobtainableDriverLicense(driver.licenseState) && !unobtainableDriverLicenseDisplayed) {
            displayUnobtainableDriverLicenseMessage(isGPA);
            setUnobtainableDriverLicenseDisplayed(true);
            return;
        }

        const isNotExcludedDriverStep = currentStep.mlStepName !== 'endorsementPaExcludedDrivers';
        if (pageAction !== 'remove' && isNotExcludedDriverStep && !showAccidentPreventionDiscountAlert && isAccidentPreventionCourse()) {
            setShowAccidentPreventionDiscountAlert(true);
            window.scrollTo(0, 0);
            return false;
        }

        clearAlerts();
        if (driver.aspects.valid && driver.aspects.subtreeValid) {
            if (MLPolicyChangeDataHolderService.getPageAction() === 'remove') {
                let removedDriver;

                const isStateCO = () => submissionVM.baseData.policyAddress.state.value.code === 'CO';

                // Cannot remove primary/secondary insured.
                const removingDriverValidationResult = validateExcludedDriverAddition(driver, submissionVM, driversVal);
                if (removingDriverValidationResult && removingDriverValidationResult.hasError && !isStateCO()) {
                    addErrorAlert(getBoldMessage(removingDriverValidationResult.errorMessage), alertNames.excludingNamedInsuredAlert);
                    return;
                }

                // Cannot exclude the only driver.
                if (driversVal.filter((d) => d.type_ML === 'rated').length === 1 && getSelectedDriver().type_ML.value.code === 'rated') {
                    addErrorAlert(getBoldMessage(messages.onlyDriverCannotBeExcluded), alertNames.excludingOnlyDriverAlert);
                    return;
                }

                const lbl = MLEndorsementUtil.stepLabel(currentStep);
                MLEndorsementUtil.setEndorsementDescription(lbl, submissionVM, translator);

                const isStateND = () => submissionVM.baseData.policyAddress.state.value.code === 'ND';
                const isStateMD = () => submissionVM.baseData.policyAddress.state.value.code === 'MD';
                const isStateKS = () => submissionVM.baseData.policyAddress.state.value.code === 'KS';
                const isStateAR = () => submissionVM.baseData.policyAddress.state.value.code === 'AR';
                const isStateWI = () => submissionVM.baseData.policyAddress.state.value.code === 'WI';

                const householdReasons = ['never_licensed', 'abroad', 'own_insurance', 'mission', 'permit'];
                const nonDriverReasons = ['unknown', 'deceased', 'abroad', 'mission', 'permit', 'not_household'];
                const householdReasonsNP = ['never_licensed', 'own_insurance', 'registeredowner', 'unabletodrive', 'notresiding'];
                 const nonDriverReasonsNP = [ 'abroad', 'mission', 'permit', 'deceased'];
                const isHouseholdReason = householdReasons.indexOf(driver.value.status_ML) > -1;
                const isNonDriverReason = nonDriverReasons.indexOf(driver.value.status_ML) > -1;
                const isHouseholdReasonsNP = householdReasonsNP.indexOf(driver.value.status_ML) > -1;
                const isNonDriverReasonsNP = nonDriverReasonsNP.indexOf(driver.value.status_ML) > -1;
                
                if ((!isModernProduct && isHouseholdReason) || (isModernProduct && isNonDriverReasonsNP) || (isModernProduct && isHouseholdReasonsNP && (isStateKS() || isStateAR() || isStateWI()))) { // Convert to household driver if never licensed, abroad, in the military, or has own insurance.
                    const selectedDriver = getSelectedDriver();
                    const originalDriver = {...driver.value, status_ML: oldDriverStatus};
                    _.set(selectedDriver, 'value.type_ML', getHouseholdNonDriverType(driver.value, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code));
                    addHouseholdAlert(selectedDriver.value, originalDriver);
                } else { // Exclusion or actual removal.
                    if (isStateND()||isStateMD()) {
                        const reasonForRemoval = driver.status_ML.value.code;
                        if ((reasonForRemoval === 'unwanted') && isSpouse(driver.value) && isLicensed(driver.value)) {
                            const selectedDriver = getSelectedDriver();
                            _.set(selectedDriver, 'value.type_ML', getExcludedDriverType());
                        }
                    } else if (isSpouse(driver.value) && isLicensed(driver.value)) {
                        addErrorAlert(getBoldMessage(messages.licensedSpouseCannotBeRemoved), alertNames.excludingLicensedSpouseAlert);
                        return;
                    }
                
                    if (isModernProduct && directRemoveStatuses.includes(driver.status_ML)) {
                        removedDriver = _.cloneDeep(driver.value);
                        _.set(removedDriver, 'status_ML', oldDriverStatus);
                          paCoverableVal.removeDriver(driver.value);
                                   updateWizardData(submissionVM);
                                   saveDriverInPortalStorage(removedDriver);
                                   removeDriverAlert(removedDriver);
                    }
                    if (isDriverRemovalExclusion(driver.value, isModernProduct)) { // Exclusions
                        // Driver is already excluded.
                        if (driverType === 'excluded') {
                            if (driver.value.status_ML === 'license_revoked') {
                                addErrorAlert(getBoldMessage(messages.alreadyExludedLicense), alertNames.alreadyExcludedLicense);
                            } else {
                                addErrorAlert(getBoldMessage(messages.alreadyExludedUnwanted), alertNames.alreadyExcludedUnwanted);
                            }
                            return;
                        }
                        // Cannot exclude if exclusions are not allowed.
                        if (!submissionVM.baseData.canExcludeDrivers_ML.value) {
                            addExclusionNotAllowedAlert();
                            const details = {
                                data: driver.person.value.getDisplayName(),
                                fixedId: driver.fixedId.value,
                                pageAction,
                                driverType
                            };
                            MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
                            jumpToSelectedStepByStepID('endorsementAdditionalChanges');
                            return;
                        }
                        const selectedDriver = getSelectedDriver();
                        if (driver.value.status_ML === 'own_insurance' && isModernProduct && checkIfNonDriver(driver.value)) {
                            _.set(selectedDriver, 'value.type_ML', getHouseholdNonDriverType(driver.value, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code));
                            const originalDriver = { ...driver.value, status_ML: oldDriverStatus };
                            addHouseholdAlert(selectedDriver.value, originalDriver);
                        } else {
                            _.set(selectedDriver, 'value.type_ML', getExcludedDriverType());
                            addExcludedAlert(selectedDriver.value);
                        }
                        saveDriverInPortalStorage(driver.value);
                    } else if (isDriverRemovalNotInHousehold(driver.value) || isDriverRemovalDuplicate(driver.value) || isDriverRemovalDeceased(driver.value) || isDriverRemovalUnknown(driver.value)) { // Actual Removal
                        removedDriver = _.cloneDeep(driver.value);
                        _.set(removedDriver, 'status_ML', oldDriverStatus);
                        addRemovedDriverToAvailableCandidates(submissionVM, driver.value);
                        paCoverableVal.removeDriver(driver.value);
                        saveDriverInPortalStorage(removedDriver);
                        removeDriverAlert(removedDriver);
                    } else if (isDriverRemovalAddRatedDriver(driver.value) && currentStep.mlStepName === ENDORSEMENT_PA_DRIVERS_STEPNAME) {
                        // rated driver cannot be removed with reason "insure_driver"
                        addErrorAlert(messages.exlcusionNotAllowed);
                        return ;
                    } else if (isDriverRemovalAddRatedDriver(driver.value)) {
                        const selectedDriver = getSelectedDriver();
                        _.set(selectedDriver, 'value.type_ML', getRatedDriverType());
                        addDriverAlert(selectedDriver.value);
                    }
                }
                if (removedDriver) {
                    const details = {
                        data: removedDriver.getDisplayName(),
                        fixedId: removedDriver.fixedId,
                        pageAction
                    };
                    MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
                    jumpToSelectedStepByStepID('endorsementAdditionalChanges');
                    return;
                }
            } else if (MLPolicyChangeDataHolderService.getPageAction() === 'add') {
                if (driverType === 'excluded' && (submissionVM.baseData.policyAddress.state.value.code === 'OR' || submissionVM.baseData.policyAddress.state.value.code === 'SC')) {
                    saveDriverInPortalStorage(driver.value);
                }
                driverType === 'rated' ? addDriverAlert(driver.value) : addExcludedAlert(driver.value);
            } else if (MLPolicyChangeDataHolderService.getPageAction() === 'edit') {
                const reasonForRemoval = driver?.status_ML?.value?.code || "";
                if (driverType === 'excluded' && submissionVM.baseData.policyAddress.state.value.code === 'UT' && (reasonForRemoval === 'unwanted' || reasonForRemoval === 'license_revoked')) {
                    addExcludedAlert(driver.value);
                    saveDriverInPortalStorage(driver.value);
                }
                 if (driverType === 'excluded' && (submissionVM.baseData.policyAddress.state.value.code === 'OR' || submissionVM.baseData.policyAddress.state.value.code === 'SC')) {
                    addExcludedAlert(driver.value);
                    saveDriverInPortalStorage(driver.value);
                }
            }
            saveEndorsement();
        }

        if (isGPA) {
            PolChangeTrackEvent('Endorsement Step Submitted', false, submissionVM, authHeader, {
                step: 'PolChange Drivers Screen',
                action: 'Drivers Submitted'
            });
        }
        
    };

    const disableValidationForDependentModifiers = (mod) => {
        if (mod && mod.hasDependentModifier_ML.value) {
            driversVal.forEach((polDriver) => {
                if (!_.isEmpty(polDriver.driverModifiers_ML)) {
                    polDriver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.isDependentModifier_ML) {
                            modifier.editMode_ML = false;
                        }
                    });
                }
            });
        }
    };

    const updateModifiers = (mod) => {
        const setEditMode = (editMode) => submissionVM.value.lobData.personalAuto.coverables.drivers.forEach((polDriver) => {
            polDriver.editMode_ML = editMode;
            polDriver.driverModifiers_ML.modifiers.forEach((driver) => {
                if(driver.codeIdentifier_ML === "PADriverSignalProgramPhoneNumber_Ext"){
                    driver.isInputValueRequired_ML = false;
                }
                polDriver.isSchoolAddressRequired_Ext = editMode;
                polDriver.schoolAddress_Ext = undefined;
            })
        });

        disableValidationForDependentModifiers(mod);
        setEditMode(false);
        const submissionLoadPromise = EndorsementService.saveEndorsement([submissionVM.value], authHeader);
        showProgressDialog(messages.saving, submissionLoadPromise, true);
        return submissionLoadPromise.then((qdd) => {
            submissionVM.value.lobData.personalAuto.coverables.drivers.length = 0;
            const sortedDrivers = _.sortBy(qdd.lobData.personalAuto.coverables.drivers, 'publicID');
            _.set(submissionVM, 'value.lobData.personalAuto.coverables.drivers', sortedDrivers);
            setSpousesForDriver(driversVal);
        }, (loadError) => {
            console.error(loadError);
            if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid) {
                setShowValidationErrors(true);
                setTimeout(()=>{
                    setErrorTimestamp(errorTimestamp+1);
                }, 500);
                return false;
            }
        }).finally(() => {
            setModifierEditMode(submissionVM.value.lobData.personalAuto.coverables.drivers, true);
            updateWizardSubmissionData(submissionVM);
        });
    };

    const isExcludedAndRequiresMVR = () => {
        const polState = _.get(submissionVM, 'baseData.policyAddress.state.value.code');
        return driverType === 'excluded' && _.includes(['MO','AK','OK'], polState);
    };

    const getPageHeaderText = () => {
        if (isAMP) {
            return driverType === 'rated' ? messages.drivers : '';
        }
        return messages.makeChanges;
    };

    const getSubHeaderText = () => {
        switch (pageAction) {
            case 'add':
                if (driverType === 'rated') {
                    return translator(messages.addDriver);
                }
                return translator(messages.addExcludedDriver);
            case 'edit':
                if (driverType === 'rated') {
                    return translator(messages.editDriver);
                }
                return translator(messages.editExcludedDriver);
            case 'remove':
                const name = MLCapitalizeStringFilter.capitalize(_.get(driver, 'person.displayName.value'));
                if (isGPA) {
                    return translator(`Remove ${name}`);
                }
                return translator(driverType === 'rated' ? `Remove driver - ${name}` : messages.removeExcludedDriver);
            default:
                break;
        }
    };

    const resolvers = {
        resolveComponentMap: {
            mlpaeditdrivercomponent: MLPAEditDriverComponent,
            mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
            mlpartialdriverdetailscomponent: MLPartialDriverDetailsComponent,
            mlreasoncomponent: MLReasonComponent,
            mldriverchangedisclosurecomponent: MLDriverChangeDisclosureComponent
        },
        resolveCallbackMap: {
            onNext
        },
        resolveClassNameMap: styles
    };

    const overrides = {
        contentContainer: {
            className: isGPA ? 'page-content-gpa' : ''
        },
        nonAccidentPreventionWarning: {
            visible: showAccidentPreventionDiscountAlert
        },
        ratedContainer: {
            visible: (pageAction === 'add' || pageAction === 'edit') && driverType === 'rated'
        },
        ratedHeaderContainer: {
            content: getSubHeaderText()
        },
        ratedHeaderMessage: {
            visible: isAMP,
            content: pageAction === 'add' ? translator(messages.ratedAddHeaderMessage) : translator(messages.ratedEditHeaderMessage)
        },
        addEditDriverComponent: {
            submissionVM,
            driverVM: driver,
            driverList: driversVal,
            showValidtionErrors: showValidationErrors,
            handleDriverModelChange: refreshData,
            updateModifiers:  (mod) => {
                updateModifiers(mod).then(() => {
                    driver.editMode_ML = true;
                });
            },
            onValidate,
            isPolicyChange: true
        },
        excludedContainer: {
            visible: (pageAction === 'add' || pageAction === 'edit') && driverType === 'excluded'
        },
        excludedHeaderContainer: {
            content: getSubHeaderText()
        },
        insuredCandidatesComponent: {
            visible: pageAction === 'add' && !isBackwardsNavigation,
            submissionVM,
            driverVM: driver,
            driverType: getExcludedDriverType(),
            setInsuredCandidateSelected,
            onValueChange: refreshData,
            showValidationErrors,
            viewModelService
        },
        formFieldsContainer: {
            visible: insuredCandidateSelected || pageAction !== 'add'
        },
        partialDriverDetailsComponent: {
            driver: driver,
            checkUniqueSelf: () => checkUniqueSelf(driversVal),
            checkUniqueSpouse: () => checkUniqueSpouse(driversVal),
            onValidate,
            showValidationErrors,
            isExcluded: driverType === 'excluded',
            submissionVM,
            viewModelService
        },
        reasonAddEditComponent: {
            driver: driver,
            onValidate,
            showValidationErrors,
            viewModelService,
            translator,
            isModernProduct
        },
        disclosureContainer: {
            visible: (pageAction === 'add' || pageAction === 'edit') && (driverType === 'rated' || isExcludedAndRequiresMVR())
        },
        disclosureComponent: {
            submissionVM,
            driver,
            refreshData,
            onValidate,
            showValidationErrors,
            isExcluded : isExcludedAndRequiresMVR()
        },
        removeContainer: {
            visible: pageAction === 'remove'
        },
        removeHeaderContainer: {
            content: getSubHeaderText()
        },
        reasonRemoveComponent: {
            driver: driver,
            removeAction: true,
            onValidate,
            showValidationErrors,
            viewModelService,
            translator,
            isModernProduct
        },
        nextDescription: {
            content: getNextStepText()
        },
        stickyContinueSection: {
            visible: isGPA,
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            onNext
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={getPageHeaderText()}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                model={submissionVM}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
                showErrors={showValidationErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

DriversPagePolChange.propTypes = wizardProps;
export default DriversPagePolChange;
